module.exports = __webpack_public_path__ + "statics/img/loginbf.a567a415.png";